import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../store/state/app.state';
import { CurrencyFunctionalityService, OutputDetailsService, SERVICE_END_POINT, UtilService, DealPartnerFunctionalityService, AnalyticsService  } from 'src/app/shared';
import { SelectedGMPQuote } from '../../../../../model/selectedGMPQuote';
import { Subscription } from 'rxjs/internal/Subscription';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { ConfigLoaderService } from 'src/app/shared/services/api-services/configLoader.service';
import { AlertModal } from 'src/app/model/alert';


@Component({
  selector: 'app-gmp-annuity-quote',
  templateUrl: './gmp-annuity-quote.component.html',
  styleUrls: ['./gmp-annuity-quote.component.scss']
})
export class GmpAnnuityQuoteComponent implements OnInit {

  @Input() SelectedGMP: SelectedGMPQuote;
  @Input() downloadFlag: boolean;
  @Input() isDocumentRequired = true;
  @Input() iterationId = 1;
  @Input() tileType;
  @Input() loadingPDFFlag;
  @Input() isValidCard=true;
  @Output() urlEmitter = new EventEmitter();
  @Output() riskQuestionEmitter = new EventEmitter();
  public contentData;

  // Temp variables
  public cmsData1;
  public url: any;
  screenName;
  public productsChoice: {};
  public productsChoiceStore: Observable<any[]>;
  valueFromStore: Observable<any[]>;
  loginDetail: any;
  public cmsDataProductChoice: any;
  public fundingSource: any;
  public keyFeatureURL: any;
  public keyFeatureSize: any;
  public termsAndConditionsURL: any;
  public termsAndConditionsSize: any;
  public selectedProductTermsAndConditions: any;
  public cmsDataProductQuote: any;
  public annuitantMaturity: any;
  public annuitantYearlyPension: any;
  public annualIncome: any;
  fieldValues: any;
  public maturityAmount: any;
  public policyTerm: any;
  protected selectedProductCode: any;
  public selectedProduct: string;
  private CMSData;
  protected selectedProductInfo: any;
  private subscripCMS: Subscription;
  public displayGmpTooltipAlert: any;
  public tooltipModalConfig: AlertModal;
  tooltipModal;
  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private analyticsService: AnalyticsService,
    private store: Store<AppState>, private configLoaderService: ConfigLoaderService,
    private outputDetailsService: OutputDetailsService, private utilService: UtilService, 
    private dealPartnerFunctionalityService: DealPartnerFunctionalityService,
    private cdr: ChangeDetectorRef) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.youroptionscalculations;
    this.cmsData1 = this.activatedRoute.snapshot.data.contentData.productQuoteComparison;
    this.cmsDataProductChoice = this.activatedRoute.snapshot.data.contentData.productChoice;
    this.cmsDataProductQuote = JSON.parse(JSON.stringify(this.activatedRoute.snapshot.data.contentData.productQuote));
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    this.url = this.activatedRoute.snapshot.data.contentData.productChoice.pensionScams.url;

    /* Adding the store to get the product to find the Funding Source and Product Code */
    this.productsChoiceStore = store.select(STORE_VAL.quote_capture);
    this.productsChoiceStore.subscribe(res => {
      if (res.length > 0) {
        //console.log(res[0]);
        this.productsChoice = res[0];
        //console.log('this product choice =>> ', this.productsChoice);
      }
    });
    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetail = res[0];
      }
    });
    this.activatedRoute.data
    .subscribe((data) => {
      this.CMSData = this.router.url === '/quote/your-saved-quotes' ? data.cmsJson['productQuote'] : data.cmsJson;
    });

  }

  /** Lifcycle hooks block */
  ngOnInit() {
    // tslint:disable-next-line:max-line-length
    this.selectedProduct = this.cmsDataProductChoice.products.find(p => p.productCode === this.SelectedGMP.selectedProduct).productName;
    // tslint:disable-next-line:max-line-length
    this.selectedProductCode = this.cmsDataProductChoice.products.find(p => p.productCode === this.SelectedGMP.selectedProduct).productCode;
    this.selectedProductInfo = this.cmsDataProductChoice.products
    .find(response => response.productCode === this.SelectedGMP.selectedProduct);
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    this.GetCMSDataServiceMapper();
  }

  emitPdfLinks() {
    const pdfUrlArray: Array<String> = [];
    pdfUrlArray.push(this.keyFeatureURL, this.termsAndConditionsURL, this.url);
    this.urlEmitter.emit(pdfUrlArray);
  }

  getInteger(numberwithdecimal) {
    const integerString = String(numberwithdecimal);
    return integerString.split('.')[0];
  }

  getFraction(numberwithdecimal) {
    if (numberwithdecimal) {
      numberwithdecimal = (Math.round(numberwithdecimal * 100) / 100);
    }
    let decimalString = String(numberwithdecimal);
    decimalString = (decimalString && decimalString.indexOf('.') > -1) ? decimalString.split('.')[1] : '';
    return decimalString.length === 1 ? decimalString + 0 : decimalString.length > 0 ? decimalString : '00';
  }

  handlePDFDetails(value: number) {
    const pdfName = value === 2 ? 'key features' : (value === 3 ? 'terms and conditions'
      : (value === 4 ? 'pension scams' : 'your personalised quote'));
    this.analyticsService.eventTrack({
      type: 'Download',
      name: pdfName,
      pageID: this.utilService.getScreenNameFromURL(this.router.url),
      applicationReferenceNo : null
    });
    switch (value) {
      case 1:
        // alert('you clicked Your Personalised Quote!');
        // this.openPersonalisedQuote();
        this.riskQuestionEmitter.emit();
        break;
      case 2:
        window.open(this.keyFeatureURL, '_blank');
        break;
      case 3:
        window.open(this.termsAndConditionsURL, '_blank');
        break;
      case 4:
        window.open(this.url, '_blank');
        break;
    }
  }

  getProductKeyFeatureUrlandSize() {
    const selectedDocument = this.selectedProductInfo.documentLink.find(res => res.key === 'keyFeatures')
      .urlArray.find(res => res.fundingSource === this.SelectedGMP.fundingSource);
    this.keyFeatureSize = selectedDocument.size;
    this.keyFeatureURL = selectedDocument.url;
  }


  getTermsAndConditionsUrlandSize() {

    this.selectedProductTermsAndConditions = this.cmsDataProductChoice.products
      .find(response => response.productCode === this.SelectedGMP.selectedProduct);
    const selectedLink = this.selectedProductTermsAndConditions.documentLink.find(res => res.name === 'Terms and conditions');
    // .Terms.find(res => res.name === "T&Cs")
    this.termsAndConditionsURL = selectedLink.url;
    this.termsAndConditionsSize = selectedLink.size;

  }


  getYourPersonalisedQuoteSize() {
    return this.cmsData1.pdf1;
  }

  getPensionScamSize() {
    return this.cmsData1.pdf4;
  }
  openPersonalisedQuote = () => {
    if (this.loginDetail && this.loginDetail.customer) {
      const customerDetail = this.loginDetail.customer;
      const recipientName = (customerDetail.title ? customerDetail.title + ' ' : '') +
        (customerDetail.forename ? customerDetail.forename + ' ' : '') +
        (customerDetail.middleName ? customerDetail.middleName + '  ' : '') +
        (customerDetail.surname ? customerDetail.surname : '');
      const inputParam = {
        addressLine1: customerDetail.address ? customerDetail.address.line1 : '',
        addressLine2: customerDetail.address ? customerDetail.address.line2 : '',
        addressLine3: customerDetail.address ? customerDetail.address.line3 : '',
        addressLine4: customerDetail.address ? customerDetail.address.line4 : '',
        countryCode: customerDetail.address ? customerDetail.address.countryCode : '',
        lifeTimeAllowanceFlag: 'N',
        isSendToTrustee: 'N',
        thirdParty: { partyType: '', address: {} },
        outputMethod: this.cmsDataProductQuote.localPrint,
        packCode: '',
        packCodeDescription: '',
        padsRefNo: (this.SelectedGMP && this.SelectedGMP.padsRefNo) ?
          this.SelectedGMP.padsRefNo : '',
        quoteRef: (this.SelectedGMP && this.SelectedGMP.quoteRefNo) ?
          this.SelectedGMP.quoteRefNo : '',
        postcode: customerDetail.address ? customerDetail.address.postcode : '',
        recipientName,
        isGMP: this.SelectedGMP ? this.SelectedGMP.isGMP : 'N'
      };
      this.outputDetailsService.generateRiskWarning(inputParam).subscribe((data: any) => {
        // this.successMessage = true;
        const file = new Blob([data], { type: 'application/pdf' });

        const nav = (window.navigator as any); 

        if (nav.msSaveOrOpenBlob) {
          nav.msSaveOrOpenBlob(file, 'Quote ref' + this.SelectedGMP.padsRefNo + '.pdf');
          // if (this.lifeTimeAllowanceFlag != null && this.lifeTimeAllowanceFlag === 'Y') {
          //   nav.msSaveOrOpenBlob(file, 'Quote ref' + quoteRequestSearchModelsWithoutLCP[i].quoteResultModel.padsRefNo
          //     + ' ' + 'Z32.pdf');
          // }
          // else {
          //   nav.msSaveOrOpenBlob(file, 'Quote ref' + quoteRequestSearchModelsWithoutLCP[i].quoteResultModel.padsRefNo
          //     + ' ' + quoteRequestSearchModelsWithoutLCP[i].packCode + '.pdf');
          // }
        } else {
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }
        this.store.dispatch({ type: 'LOADING_ICON', loadingIcon: false });
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          //console.log('Client-side error occured.');
        } else {
          //console.log(err);
          // this.successMessage = false;
          // this.store.dispatch({ type: 'LOADING_ICON', loadingIcon: false });
        }
      });
    }
  }
  checkProperties = (obj) => {
    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== '') {
        return false;
      }
    }
    return true;
  }
   /** Code block for CMS */
   GetCMSDataServiceMapper() {
    
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.cmsDataProductQuote.gmpQuoteTitle = this.CMSData.string_GMPProductName;
        this.cmsDataProductQuote.expiryNotification.infoIconData.content = this.CMSData.string_QuoteGuaranteeInformationWording_1 +
        this.SelectedGMP.quoteExpiry + this.CMSData.string_QuoteGuaranteeInformationWording_2;
        this.cmsData1.keyFeature1 = this.CMSData.string_OpenQuotePdfCTALabel;
        this.cmsData1.keyFeature2 = this.CMSData.pdfBlock.string_KeyfeaturesPdfTitle;
        this.cmsData1.keyFeature3 = this.CMSData.pdfBlock.string_TermsandConditionsPdfTitle;
        this.cmsData1.keyFeature4 = this.CMSData.pdfBlock.string_OpenPensionScamsPdfCTALabel;

        /** PDF Mappers */
        /* Key Features */
        // this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => ele['fundingSource'] === 'I').url =
        // this.CMSData.pdfBlock.GARGMPUrl_S430;
        // this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => ele['fundingSource'] === 'B').url =
        // this.CMSData.pdfBlock.GARGMPUrl_S430;
        // tslint:disable-next-line:max-line-length
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(ele['fundingSource'])).url =
        this.CMSData.pdfBlock.pruURL_Q0059291;
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => ele['fundingSource'] === 'H').url =
        this.CMSData.pdfBlock.aegonURL_Q0054471;
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => ele['fundingSource'] === 'F').url =
          this.configLoaderService.configuration.isSlocRemoved ? this.CMSData.pdfBlock.PhoenixPA_KFD_DA2124 : this.CMSData.pdfBlock.slocURL_W13830;
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => ele['fundingSource'] === 'J').url =
        this.CMSData.pdfBlock.reAssureURL_Q0059211;
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => ele['fundingSource'] === 'O').url =
        this.CMSData.pdfBlock.PhoenixPA_KFD_DA2124;
        if (this.SelectedGMP && this.SelectedGMP.fundingSource) {
          // tslint:disable-next-line:max-line-length
          this.cmsDataProductChoice.products.find(response => response.productCode === this.SelectedGMP.selectedProduct).documentLink.find(res => res.name === 'Terms and conditions').url =
           this.SelectedGMP.fundingSource === 'H' ? this.CMSData.pdfBlock.aegonGARGMPURL_Q0054812 : this.CMSData.pdfBlock.gargmpUrl_S430;
        }
        if((this.selectedProductInfo.productCode == 'H' || this.selectedProductInfo.productCode == 'G') && this.productsChoice &&  this.productsChoice['source'] == 'J') {
          this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
            ele['fundingSource'] === 'J').url = this.selectedProductInfo.productCode === 'H' ?
            this.CMSData.pdfBlock.reAssureFTRP_KFDURL_Q0059214 : this.selectedProductInfo.productCode === 'G' ? this.CMSData.pdfBlock.reAssureCORP_KFDURL_Q0059217 : this.CMSData.pdfBlock.reAssureURL_Q0059211;
        }
        this.cmsDataBinding();
      }
  }

  /** End of code block for CMS */
  cmsDataBinding() {
  if (this.isDocumentRequired) {
    this.getProductKeyFeatureUrlandSize();
    this.getTermsAndConditionsUrlandSize();
    this.emitPdfLinks();
  }
  if (this.cmsDataProductQuote) {
    const iconData = this.SelectedGMP.quoteExpiry;
    // tslint:disable-next-line:max-line-length
    this.cmsDataProductQuote.expiryNotification.infoIconData.content = this.cmsDataProductQuote.expiryNotification.infoIconData.content.replace('{}', iconData);
  }
 }    /** For web tracking */
getCurrentScreenURL() {
  this.screenName = this.utilService.getScreenNameFromURL(this.router.url);

  return this.screenName;
}
ngOndestroy () {
  if (this.subscripCMS) {
    this.subscripCMS.unsubscribe();
  }
}
}
